import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import LoginForm from "./LoginForm";
import { useNavigate } from "react-router-dom";

function Footer({ user, onLogin, onFirstLogin, onLogout }) {
  const [showLogin, setShowLogin] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // Hide footer content on change-password page
  if (location.pathname === "/change-password") {
    return <footer className="app-footer" />;
  }

  return (
    <footer className={`app-footer ${user ? "sticky-footer" : ""}`}>
      <div className="footer-content">
        {user ? (
          <div className="admin-group">
            <span className="admin-status">
              Logged in as <strong>{user.username}</strong>
            </span>

            <div className="admin-actions">
              <button onClick={() => navigate("/admin")}>
                Open Admin Form
              </button>
              <button onClick={onLogout}>Logout</button>
            </div>

          </div>
        ) : (
          <>
            {!showLogin ? (
              <button
                className="login-toggle"
                onClick={() => setShowLogin(true)}
              >
                Staff Login
              </button>
            ) : (
              <div className="login-panel">
                <LoginForm
                  onLogin={onLogin}
                  onFirstLogin={onFirstLogin}
                />
                <button
                  className="login-cancel"
                  onClick={() => setShowLogin(false)}
                >
                  Cancel
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </footer>
  );
}

export default Footer;
